import { CollapsiblePanel, Panel } from "../../../widgets";
import { ControlType, Property, PropertyType } from "../../../base/types";

import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { SPListItems } from "./components/SPListItems";
import { useGetProperties } from "../../../base/hooks";

export const SPDocumentsComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });

    const title: string | undefined = properties[Property.Title]
    const headerClass: string | undefined = properties[Property.HeaderClass]
    const relativePath: string | undefined = properties[Property.RelativePath];
    const allowUpload: boolean | undefined = properties[Property.InsertAllowed];
    const allowDelete: boolean | undefined = properties[Property.DeleteAllowed];
    const collapsible: boolean | undefined = properties[Property.Collapsible];
    const createFolder: boolean | undefined = properties[Property.EnsurePath];

    if (collapsible) {
        return (
            <CollapsiblePanel
                eventKey="documents"
                className={className}
                header={title}
                icon="GridViewOutlined"
                headerClass={headerClass}
            >
                {relativePath && <SPListItems
                    relativePath={relativePath}
                    createFolder={createFolder}
                    allowUpload={allowUpload}
                    allowDelete={allowDelete} />}
            </CollapsiblePanel>
        )
    }

    return (
        <Panel
            className={className}
            header={title}
            icon="GridViewOutlined"
            headerClass={headerClass}>
            {relativePath && <SPListItems
                relativePath={relativePath}
                createFolder={createFolder}
                allowUpload={allowUpload}
                allowDelete={allowDelete} />}
        </Panel>)
}

Registry.addControl({
    id: "11eb5373-c00f-4793-aed4-a4b7013d80a4",
    name: "SharePoint Documents",
    type: ControlType.SharePointDocuments,
    properties: [
        { id: Property.Title, name: 'Title', type: PropertyType.String },
        { id: Property.RelativePath, name: 'Relative Path', type: PropertyType.String },
        { id: Property.EnsurePath, name: 'Create Folder', type: PropertyType.Boolean },
        { id: Property.Collapsible, name: 'Collapsible', type: PropertyType.Boolean },
        { id: Property.HeaderClass, name: 'Header Class', type: PropertyType.String },
        { id: Property.InsertAllowed, name: 'Allow Upload', type: PropertyType.Boolean },
        { id: Property.DeleteAllowed, name: 'Allow Delete', type: PropertyType.Boolean },
    ],
    component: SPDocumentsComponent
})
